import { format } from "date-fns/format";
import React from "react";

import { ReactComponent as CalendarIcon } from "../icon-temp/calendar-icon.svg";

export const CurrentBillingPeriodCounting = ({ startAt, endAt }) => {
  return (
    <>
      <h2 className="section-title heading h4">Billing period</h2>
      <div className="spacer--small" />
      <p style={{ display: "flex", alignItems: "center" }}>
        <span style={{ display: "flex", paddingRight: "5" }}>
          <CalendarIcon width="24" height="24" />
        </span>
        {format(startAt, "d MMMM")} — {format(endAt, "d MMMM")}
      </p>
    </>
  );
};
